<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Monthly Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <router-link to="/lps/report/view/vendor">Report</router-link>
      /
      <b>Monthly Report</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">

        <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
            <span class="m-auto"></span>
            <!-- <div class="btn-group col-lg-6 col-sm-12 pl-0 pl-sm-3" role="group">
                <button class="btn btn-secondary" id="btn-active" type="button" @click="active()">Active</button>
                <button class="btn btn-secondary" id="btn-pending" type="button" @click="pending()">Pending</button>
            </div> -->
        </div>
    </div>


    <div class="row mb-4">
      <div class="col-md-12 mb-4">

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
              
            <div id="active" class="">
                <h4 class="card-title mb-3">
                <b>{{ title }}</b>
                </h4>

                <!-- Active -->
                <div class="table-responsive">
                    <table  id="payout_tbl"  class="display table table-striped table-bordered"  style="width:100%; text-align: center;">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Product & Services</th>
                                <th>Price ($)</th>
                                <th>Transaction Type</th>
                                <th>Transaction Date</th>
                                <th>Customer Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(redeem, index) in redeems" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ redeem.product }}</td>
                                <td>{{ redeem.price }}</td>
                                <td>{{ redeem.type }}</td>
                                <td>{{ redeem.date }}</td>
                                <td>{{ redeem.account_number }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


    <script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-payout",
  components: {},

  data() {
    return {
      redeems: [],
      title: ""
    };
  },

  methods: {
    loadRedeem() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id
      let month = this.$route.params.month
      let year = this.$route.params.year

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(axios.lpsURL + "/point/redeem/filter", 
          {
            "month": month,
            "year": year,
            "vendor_id": id
          },
          {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.redeems = res.data.redeems;

            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            let month1 = months[month - 1]

            this.title = month1 + " " + year + " Report"

          })
          .then(function() {
            $("#payout_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    loadData() {
      this.destroyDatatable();
      this.loadRedeem();
    },

    destroyDatatable() {
      $("#payout_tbl").DataTable().destroy();
    },

    redirectUpload() {
      let id = this.$route.params.id
      let month = this.$route.params.month

      return "/payout/invoice/" + id + "/" + month;
    }

  },

  mounted() {
    this.loadData();
  }
};
</script>
